import React from 'react';

const ProjectAccordion = ({ projectArray }) => {
  return (
    <div id="accordion2">
      {projectArray.map((projectInfo, index) => {
        const accordion2Id = `collapse-${index}`;

        return (
          <div key={index} className="card">
            <div className="card-header2" id={`heading-${index}`}>
              <h5 className="mb-0">
                <button
                  className="btn acbtn2"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${accordion2Id}`}
                  aria-expanded="true"
                  aria-controls={accordion2Id}
                >
                  {projectInfo.projectName}
                </button>
              </h5>
            </div>
            <div id={accordion2Id} className="collapse" aria-labelledby={`heading-${index}`} data-bs-parent="#accordion2">
              <div className="card-body">
                <h5 className="text-light">Project Details</h5>
                <div className="cdiv p-3 rounded">
                  <div className="row">
                    <div className="col-12">
                      <p className="card-text">Project Name:</p>
                    </div>
                    <div className="col-12 mx-5">
                      <b>
                        <p className="card-text">{projectInfo.projectName}</p>
                      </b>
                    </div>
                  </div>
                  {/* <br /> */}
                  <div className="row">
                    <div className="col-6">
                      <p className="card-text">No of members:</p>
                    </div>
                    <div className="col-2">
                      <p className="card-text">{projectInfo.member}</p>
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <p className="card-text">Tools & Techniques:</p>
                    <ul className="text-lg-start pro mx-5">
                      <li>
                        <a href="/">{projectInfo.tool1}</a>
                      </li>
                      <li>
                        <a href="/">{projectInfo.tool2}</a>
                      </li>
                      <li>
                        <a href="/">{projectInfo.tool3}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProjectAccordion;
